export const getLoginReferrer = (location = {}) => {
  const locationState = location.state || {}

  if (Object.prototype.hasOwnProperty.call(locationState, 'referrer')) {
    return locationState.referrer
  }

  const referrer = new URLSearchParams(location.search || '').get('referrer')
  return referrer || ''
}
